<script setup lang="ts">
  import ErrorDialog from './components/ErrorDialog.vue'
  import { useThemeConfig } from './composables/useThemeConfig'
  import AppShell from './layout/AppShell.vue'
  import AppMainMenu from './layout/AppMainMenu.vue'
  import { FieldRoot, LoadingProvider } from '@gat-ship/vue-components'
  import { NotificationProvider } from '@gat-ship/notifications'
  import { SupportSessionHeader } from '@gat-ship/support'
  import AppContexts from './AppContexts.vue'

  useThemeConfig()

  /**
   * Workaround for Chrome discarding and restoring tabs. We reload so the
   * user doesn't end up interacting with stale data after a long pause.
   */
  document.addEventListener('visibilitychange', () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { wasDiscarded, visibilityState } = document as any
    if (visibilityState === 'visible' && wasDiscarded) {
      window.location.reload()
    }
  })
</script>

<template>
  <FieldRoot variant="stacked">
    <LoadingProvider>
      <NotificationProvider>
        <AppContexts>
          <SupportSessionHeader />
          <!-- Routes with `meta.bareLayout` render without the app chrome. -->
          <router-view v-if="$route.meta.bareLayout === true" />
          <AppShell v-else>
            <template #main-menu-content>
              <AppMainMenu />
            </template>
            <template #main>
              <router-view />
            </template>
          </AppShell>
        </AppContexts>
        <ErrorDialog />
      </NotificationProvider>
    </LoadingProvider>
  </FieldRoot>
</template>
